import type { Store } from '@tanstack/react-store';
import { useStore } from '@tanstack/react-store';
import type { SortingState } from '@tanstack/react-table';

interface ManagementPaginationState {
  currentPage: number;
  totalPages: number;
  total: number;
}

interface ManagementUiState {
  isLoading: boolean;
}

interface ManagementStoreState<TFilters> {
  filters: TFilters;
  sorting: SortingState;
  pagination: ManagementPaginationState;
  ui: ManagementUiState;
}

export function useManagementPageState<
  TState extends ManagementStoreState<unknown>,
>(store: Store<TState>) {
  const filters = useStore(
    store,
    (state) => state.filters,
  ) as TState['filters'];
  const sorting = useStore(store, (state) => state.sorting);
  const pagination = useStore(store, (state) => state.pagination);
  const isLoading = useStore(store, (state) => state.ui.isLoading);

  return {
    filters,
    sorting,
    pagination,
    isLoading,
  };
}
